export default "__VITE_ASSET__C$xaXwX3__"